import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var FormControl = styled.div.withConfig({
  displayName: "partials__FormControl",
  componentId: "sc-hn92hv-0"
})(["display:flex;justify-content:center;"]);
var borderStyles = css(["border:1px solid ", ";border-radius:", ";box-shadow:inset 0 0 2px ", ";transition:all 0.3s ease-in-out;", ";"], function (_ref) {
  var theme = _ref.theme,
    isFocused = _ref.isFocused;
  return isFocused ? theme.colors.primaryM : theme.colors.terciaryM;
}, function (_ref2) {
  var isLeft = _ref2.isLeft,
    isRight = _ref2.isRight;
  return isLeft ? '4px 0 0 4px' : isRight ? '0 4px 4px 0' : '0px';
}, function (_ref3) {
  var theme = _ref3.theme,
    isFocused = _ref3.isFocused;
  return isFocused ? theme.colors.primaryM : theme.colors.terciaryM;
}, function (_ref4) {
  var isLeft = _ref4.isLeft,
    isRight = _ref4.isRight;
  return isLeft ? 'border-right: 0;' : isRight ? 'border-left: 0;' : '';
});
var smallStyles = css(["padding:6px;", ""], getFont(-1, 'default'));
var mediumStyles = css(["padding:9px;", ""], getFont(0, 'default'));
export var DateBlock = styled.div.withConfig({
  displayName: "partials__DateBlock",
  componentId: "sc-hn92hv-1"
})(["", " ", " select{width:100%;font-family:", ";text-align:", ";", " ", "}"], borderStyles, function (_ref5) {
  var marginLeft = _ref5.marginLeft;
  return marginLeft && 'margin-left: 8px;';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.bodyFontFamily;
}, function (_ref7) {
  var textAlign = _ref7.textAlign;
  return textAlign;
}, function (_ref8) {
  var size = _ref8.size;
  return size === 'small' && smallStyles;
}, function (_ref9) {
  var size = _ref9.size;
  return size === 'medium' && mediumStyles;
});
export var ShortcutBlock = styled.div.withConfig({
  displayName: "partials__ShortcutBlock",
  componentId: "sc-hn92hv-2"
})(["margin-top:24px;text-align:center;"]);